import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetScheduleSyncUser } from "../../../store/ScheduleSync/ScheduleSyncUserAction";
import StatusCode from "../../../util/StatusCode";
import TableVertical from "../../misc/TableVertical";
import { useTranslation } from "react-i18next";
import { ScheduleSync_CoreUser } from "../../../models/CoreScheduleSyncModels";
import { RequestState } from "../../../models/RequestState";
import * as Helper from '../../../util/Helper';
import { RootState } from "../../../store/store";


const ScheduleSyncUserInfo = () => {
    const { t } = useTranslation(['common', 'scheduleSync']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const user = useSelector<RootState, RequestState<ScheduleSync_CoreUser>>(state => state.schedulesync_users.user);

    useEffect(() => {
        if (userId) {
            GetScheduleSyncUser(userId)(dispatch);
        }
    }, [dispatch, userId]);
    
    const renderInfo = () => {
        let info = [];

        if (user.code === StatusCode.COMPLETE) {
            info.push(
                { header: t('user.infoTableHeaders.displayName', { ns: 'scheduleSync' }), content: user.data.displayName },
                { header: t('genericTableHeaders.active', {ns: 'common' }), content: Helper.active(user.data.active) },
                { header: t('user.infoTableHeaders.email', {ns: 'scheduleSync'}), content: user.data.emailAddress },
            )
        }

        return (
            <TableVertical
                header={t('commonTableHeaders.information', {ns: 'scheduleSync'})}
                info={info}
                error={user.code === StatusCode.ERROR}
                searching={user.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderInfo()}
    </>)
}

export default ScheduleSyncUserInfo;
